<script setup>
import { toRefs } from "vue";
import moment from "moment";
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";

const props = defineProps({
  livelihood: {
    type: Object,
  },
});

const { livelihood } = toRefs(props);

const formatDate = (date) => {
  return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
};
</script>

<template>
  <div v-if="Object.keys(livelihood).length > 0" class="pa-5">
    <h1>{{ livelihood.name }}</h1>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2"><v-icon>mdi-briefcase</v-icon> Livelihood Data</h3>
          <InfoHolder title="Livelihood Title" :info="livelihood.name" />
          <InfoHolder title="Date" :info="formatDate(livelihood.date)" />
          <InfoHolder
            title="Beneficiary Name"
            :info="livelihood.beneficiary?.name"
          />
          <InfoHolder title="Branch" :info="livelihood.branch?.name" />
          <InfoHolder
            title="Responsible Officer"
            :info="livelihood.responsibleOfficer?.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-employability));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-employability));
      h3 {
        background-color: rgb(var(--v-theme-employability));
        color: black;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
